export type HorizontalShotSelectionDirection = "next" | "prev";

export type HorizontalShotSelection = {
  selectedKeys: string[];
  focusKey: string;
};

export function resolveHorizontalShotSelection(
  orderedKeys: string[],
  selectedKeys: string[],
  direction: HorizontalShotSelectionDirection,
  extend: boolean
): HorizontalShotSelection | null {
  if (orderedKeys.length === 0) {
    return null;
  }

  const selectedKeySet = new Set(selectedKeys);
  const selectedIndexes = orderedKeys
    .map((key, index) => selectedKeySet.has(key) ? index : -1)
    .filter((index) => index >= 0);
  if (selectedIndexes.length === 0) {
    const focusIndex = direction === "next" ? 0 : orderedKeys.length - 1;
    return {
      selectedKeys: [orderedKeys[focusIndex]],
      focusKey: orderedKeys[focusIndex]
    };
  }

  const edgeIndex = direction === "next"
    ? Math.max(...selectedIndexes)
    : Math.min(...selectedIndexes);
  const focusIndex = edgeIndex + (direction === "next" ? 1 : -1);
  if (focusIndex < 0 || focusIndex >= orderedKeys.length) {
    return null;
  }

  const focusKey = orderedKeys[focusIndex];
  if (!extend) {
    return { selectedKeys: [focusKey], focusKey };
  }

  selectedKeySet.add(focusKey);
  return {
    selectedKeys: orderedKeys.filter((key) => selectedKeySet.has(key)),
    focusKey
  };
}
